import { AccountUser } from '@quick/client';

export const displayName = (accountUser: AccountUser): string => {
  return `${accountUser.firstName} ${accountUser.lastName}`;
};
